import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import { mapState } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FeesCost",
  components: _objectSpread({}, FieldComponents),
  props: {
    feeCost: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      editingFeeName: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("ApplicationStore", ["feesTranslationMap"])), {}, {
    feeName() {
      return this.$options.filters.getSchemaTranslation(this.feeCost.feeName, this.feesTranslationMap);
    },
    feeCostAmount: {
      get() {
        return this.feeCost.amount;
      },
      set(value) {
        // TODO: Refactor this component mutating prop directly
        //eslint-disable-next-line vue/no-mutating-props
        this.feeCost.amount = _parseFloat(value);
      }
    },
    computedComment: {
      get() {
        return this.feeCost.comment;
      },
      set(value) {
        //eslint-disable-next-line vue/no-mutating-props
        this.feeCost.comment = value || "";
      }
    }
  }),
  methods: {
    startEditFeeName() {
      if (this.feeCost.defaultFee) return;
      this.editingFeeName = true;
    },
    stopEditFeeName() {
      this.editingFeeName = false;
    },
    removeFeeCost() {
      this.$emit("remove");
    },
    save() {
      this.$emit("save");
    }
  }
});